import { FC } from 'react';
import { TSession } from '@fe-learner-common/api/schemas/sessionsSchema';
import { Link } from 'react-router-dom';
import { publishAnalyticsEvent } from '@utils/publishAnalyticsEvent';
import { CourseImage, Tag } from '@fe-learner-common';
import { useSessionThumbnail } from '@hooks/useImageUrl';
import { useSessionTags } from '@hooks/useSessionTags';

type CourseCardProps = {
  session: TSession;
};

const Card: FC<CourseCardProps> = ({ session }) => {
  const thumbnail = useSessionThumbnail({ session });
  const tags = useSessionTags(session);
  return (
    <>
      <CourseImage thumbnail={thumbnail} alt={session.name || ''} />
      <div className="flex items-center pb-1 pt-3">
        <h3 className="py-1.5 text-label-lg">{session.name}</h3>
      </div>
      <div className="flex">
        {tags
          ? Object.entries(tags).map(([key, value]) => (
              <Tag
                key={`tag-${session.uuid}-${key}`}
                icon={value.icon}
                type={value.type}
              >
                {value.text}
              </Tag>
            ))
          : null}
      </div>
    </>
  );
};

export const CourseCard: FC<CourseCardProps> = ({ session }) => {
  return (
    <Link
      data-testid="course-card"
      tabIndex={0}
      className={
        'flex h-full cursor-pointer flex-col rounded-2xl p-3 hover:bg-neutral-100 sm:m-0 sm:size-auto'
      }
      to={{
        pathname: `/session/${session.uuid}/`,
      }}
      onClick={() => {
        publishAnalyticsEvent(
          {
            context: 'CatalogPage',
            action: 'CourseCardClicked',
          },
          {
            courseId: session?.uuid,
          },
        );
      }}
    >
      <Card session={session} />
    </Link>
  );
};
